export default "__VITE_ASSET__DMGXPIsh__"